import { createContext, useContext } from 'react';
import { PortalConfig } from '@/lib/portalConfig';

const PortalContext = createContext<PortalConfig | null>(null);

export function PortalProvider({ config, children }: { config: PortalConfig; children: React.ReactNode }) {
  return <PortalContext.Provider value={config}>{children}</PortalContext.Provider>;
}

export function usePortal(): PortalConfig {
  const ctx = useContext(PortalContext);
  if (!ctx) throw new Error('usePortal must be used within a PortalProvider');
  return ctx;
}

/** Safe version that returns null outside a portal (for shared components) */
export function usePortalOptional(): PortalConfig | null {
  return useContext(PortalContext);
}

/** Get the base path — works inside or outside a portal */
export function useBasePath(): string {
  const ctx = useContext(PortalContext);
  return ctx?.basePath ?? '';
}
